import { rescalePrice } from "@common/helpers/scaleInput";
import type { IWeightFormatter } from "@common/helpers/WeightFormatter";

type ToggleResult = {
  unit: string;
  amount: number | null;
  valuePerUnit: number | null;
};

const toggleHarvestUnits = (
  formatter: IWeightFormatter,
  currentUnit: string,
  amount: number | null,
  valuePerUnit: number | null
): ToggleResult => {
  const newUnit = formatter.alternateUnit(currentUnit);

  const newAmount =
    amount !== null
      ? formatter.toSpecificUnit(formatter.fromDisplayUnit(amount, currentUnit), newUnit)
      : null;

  const newValuePerUnit =
    valuePerUnit !== null
      ? rescalePrice(
          valuePerUnit,
          formatter.fromDisplayUnit(1, currentUnit),
          formatter.fromDisplayUnit(1, newUnit)
        )
      : null;

  return { unit: newUnit, amount: newAmount, valuePerUnit: newValuePerUnit };
};

export default toggleHarvestUnits;
